import { CustomerOrder } from "@eco/client"
import { useEcoClient, useEcoMutation } from "hooks"

export const useBraintreeValidate = () => {
    const ecoClient = useEcoClient()

    return useEcoMutation((payload: BraintreeValidateProps) => {
        return ecoClient.post<BuyValidateResponse>({
            path : 'braintree/validate',
            data: payload
        })
    })
}

type BraintreeValidateProps = {
    customerorderId: number
    lg?: string
}

type BuyValidateResponse = {
    orderStatus: CustomerOrder['status'],
    customerorderId: number
}
